var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"no-close-on-backdrop":true,"title":_vm.Core.Definition.getDefinition('Modification'),"hide-footer":true},model:{value:(_vm.dataShow),callback:function ($$v) {_vm.dataShow=$$v},expression:"dataShow"}},[_c('DynamicForm',{ref:"dynamicForm",attrs:{"ignoreRouteParamId":true,"getRoot":"/binder-audit","saveRoot":"/binder-audit","options":_vm.dataOptions,"formStructure":_vm.dataFormStructures.form},on:{"onInit":_vm.onInit,"onSave":_vm.onSave,"onInitSuccess":_vm.onInitSuccess,"onRequestSuccess":_vm.onRequestSuccess,"onSaveSuccess":_vm.onSaveSuccess},model:{value:(_vm.dataId),callback:function ($$v) {_vm.dataId=$$v},expression:"dataId"}},[_vm._t("default",[_c('InputInstanceSelector',{ref:"modalInstanceSelector",attrs:{"label":_vm.Core.Definition.getDefinition('Sélectionnez un index'),"emptyMessage":_vm.Core.Definition.getDefinition('Associez un index au registre de modification'),"searchArgs":_vm.binderIndexSearchArgs,"instanceSelector":{
                    root: '/binder-index/list',
                    searchFormStructure: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'title'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: _vm.Core.Definition.getDefinition('Titre'),
                                value: ''
                            }
                        ]
                    },
                    data: {},
                    options: {
                        pagination: true,
                        header: true,
                        responsive: false,
                        striped: true,
                        headerStyle: '1',
                        emptyText: _vm.Core.Definition.getDefinition('Aucun élément à afficher'),
                        borderVariant: 'white',
                        noBody: true
                    },
                    columns: [
                                    {
                                        label: _vm.Core.Definition.getDefinition('Position'),
                                        key: 'position',
                                        sortable: true
                                    },
                                    {
                                        label: _vm.Core.Definition.getDefinition('Titre'),
                                        key: 'title',
                                        sortable: true
                                    }
                    ],
                    label: 'title',
                    id: 'id'
                }},model:{value:(_vm.dataBinderIndex),callback:function ($$v) {_vm.dataBinderIndex=$$v},expression:"dataBinderIndex"}}),(_vm.Core.Validation.isId(_vm.dataBinderIndex.id))?_c('InputInstanceSelector',{ref:"modalInstanceSelector",attrs:{"label":_vm.Core.Definition.getDefinition('Sélectionnez un formulaire'),"emptyMessage":_vm.Core.Definition.getDefinition('Associez un formulaire au registre de modification'),"searchArgs":_vm.binderFormSearchArgs,"instanceSelector":{
                    root: '/binder-form/list',
                    searchFormStructure: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'position'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'position',
                                type: 'text',
                                label: _vm.Core.Definition.getDefinition('Position'),
                                value: ''
                            }
                        ]
                    },
                    data: {},
                    options: {
                        pagination: true,
                        header: true,
                        responsive: false,
                        striped: true,
                        headerStyle: '1',
                        emptyText: _vm.Core.Definition.getDefinition('Aucun élément à afficher'),
                        borderVariant: 'white',
                        noBody: true
                    },
                    columns: [
                                    {
                                        label: _vm.Core.Definition.getDefinition('Position'),
                                        key: 'position',
                                        sortable: true
                                    }
                    ],
                    label: 'position',
                    id: 'id'
                }},model:{value:(_vm.dataBinderForm),callback:function ($$v) {_vm.dataBinderForm=$$v},expression:"dataBinderForm"}}):_vm._e()],{"slot":"afterForm"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }